export default "__VITE_ASSET__BY412J9o__"